import * as React from "react";
import "./App.css";
import Luckysheet from "./SpreadSheet/Luckysheet";
import { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import {
  baseUrl,
  staticExclusionData,
  staticExclusionCsrData, confidenceScoreConfigStaticData, staticSummaryReviewChecklistData
} from "./Services/Constants";
import Util from "./Services/utils";
import { AppSidebar } from "../src/Layouts/Sidebar";
import axios from "axios";
import jwt_decode from "jwt-decode";
import {
  processAndUpdateToken,
  setMasterData,
  getObservationKey,
  getTableApplicationColumns,
  getPageKey,
  isARType,
  splitPageKekFromTextForDataRendering,
  getTextByRequirement,
  SetCheckListQuestionMasterData,
  getRespectiveTableName, getCsRespectiveColumn, getFeedBackRespectiveColumn, getJobFiles,
  setDocumentDetails, GetCheckListQuestionMasterData ,getLockableColumns
} from "./Services/CommonFunctions";
import CsrSheet from "./SpreadSheet/CsrSheet";
import DefaultDataSheet from "./SpreadSheet/DefaultDataSheet";
import {
  JobHeaderData,
  JobCDData,
  JobJCData,
  JobF1Data,
  JobF2Data,
  JobF3Data,
  JobF4Data,
  JobConfigData,
  JobPRTotalCount,
  ComponentRenderApi
} from "./Services/PreviewChecklistDataService";
import { auditProcessNames } from "./Services/enums";
import { updateGridAuditLog, GetConfidenceScoreConfig ,getOverrideConfig} from "./Services/PreviewChecklistDataService";
import { SimpleSnackbarWithOutTimeOut } from "./Components/SnackBar";
import QCNoneditable from "./SpreadSheet/QCNoneditable";
import { useNavigate } from 'react-router-dom';


function App(props) {
  const util = new Util();
  const reference = React.useRef();
  const [jobData, setJobData] = useState();
  const [checklistData, setChecklistData] = useState();
  const [filteredChecklistData, setFilteredChecklistData] = useState([]);
  const [csrChecklistData, setCsrChecklistData] = useState();
  const [csrFormsData, setCsrFormsData] = useState();
  const [csrQacData, setCsrQacData] = useState();
  const [formData, setFormData] = useState();
  const [exclusionData, setExclusionData] = useState();
  const [summaryReviewChecklistData, setSummaryReviewChecklistData] = useState();
  const [defaultSheetNameData, setDefaultSheetNameData] = useState();
  const [isValue, setIsValue] = useState(false);
  const [isReadonly, setIsReadonly] = useState(false);
  const [selectedJob, setSelectedJob] = useState();
  // const [defaultBaseData, setdefaultBaseData] = useState(props?.qcData);
  const [jobName, setJobName] = useState();
  const [msgVisible, setMsgVisible] = useState(false);
  const [sheetRenderConfig, setSheetRenderConfig] = useState({
    PolicyReviewChecklist: "false",
    FormsCompare: "false",
    Exclusions: "false",
    QAC_not_answered_questions: "false",
    SummaryReviewChecklist: "false",
  });
  const [msgClass, setMsgClass] = useState("");
  const [msgText, setMsgText] = useState("");
  const [Qacdata, setQacdata] = useState("");
  const [jobId, setJobId] = useState();
  const [gradtionData, setGradtionData] = useState();
  const [sheetListOptionSet, setSheetListOptionSet] = useState();
  const [selectedSheet, setSelectedSheet] = useState("Summary Checklist");
  const [confidenceScoreConfig, setConfidenceScoreConfig] = useState([]);
  const [enableExclusionCellLock, setEnableExclusionCellLock] = useState(true);
  const [sqCodesState, setSqCodesState] = useState([]);
  const [checklistypeState, setChecklistypeState] = useState([]);
  const location = useLocation();
  const [overrideConfig,setOverrideConfig] = useState([]);
  const navigate = useNavigate();
  const renderBrokerIdsQac = ["1162"];  //"Cottingham Butler"
  const notToFilterBrokers = ["1010", "1124", "1020", "1123", "1159", "1154", "1017", "1018"];
  const cellOverRideDisableBroker = ["1004", "1099"];
  let url = new URL(window.location.href);
  let jobIdForCellRide = url?.searchParams.get("jobId") || url?.searchParams.get("jobid");

  let token = sessionStorage.getItem("token");
  let isIntialRender = true;

  useEffect(() => {
    sessionStorage.removeItem("jobDocumentData");
    document.body.classList.add('loading-indicator');
    try {
      if (isIntialRender) {

        let jobId = url?.searchParams.get("jobId") || url?.searchParams.get("jobid");
        let urlParamToken = url?.searchParams.get("token");
        let userParamId = url?.searchParams.get("userId");

        // New logic to handle token and jobId for xlpage **START**
        if (location.pathname === "/xlpage") {
          if (!jobId || !urlParamToken) {
            navigate('/job');
            return;
          }
          const decodedToken = atob(urlParamToken || "");
          if (jobId !== decodedToken) {
            navigate('/job');
            return;
          }
          if (userParamId) {
            const decodedUserId = atob(userParamId || "");
            if (decodedUserId) {
              sessionStorage.setItem("userName", decodedUserId);
            }
          }
        }
        // New logic to handle token and jobId for xlpage **END**
        setJobId(jobId);
        const brokerId = jobId.slice(0, 4);
        if (
          urlParamToken &&
          urlParamToken.length > 15 &&
          (location.pathname === "/csrView" || location.pathname === "/csrview")
        ) {
          updateCsrEntry(jobId, 'CsrJobValidation-Initial-Entry', false);
          csrAuthenticationTokenApi();
        }
        else if (
          (location.pathname === "/csrView" || location.pathname === "/csrview") &&
          (!(!urlParamToken || urlParamToken <= 15) || urlParamToken == null)
        ) {
          updateCsrEntry(jobId, 'CsrJobValidation-Initial-Error', true);
        }
        GetCheckListQuestionMasterData(token, jobId);
        const value = parseInt(util.getUrlParameterId());
        let listOfCalls = [1, 2, 3, 5, 6, 7, 8, 9, 10, 11, 13, 14];
        ComponentRenderApiFun(jobId).then(async (userRes) => {
          if (userRes === "redirected" && location.pathname === "/xlpage") {
            document.body.classList.remove('loading-indicator');
            return;
          }
          if (!userRes || (location.pathname === "/csrView" && userRes === sessionStorage.getItem("csrAuthUserName")) || (location.pathname === "/xlpage" && userRes === sessionStorage.getItem("userName"))) {
            updateGridAuditLog(jobId, auditProcessNames.JobFetchProcessInitiated, "");
          } else {
            updateGridAuditLog(jobId, auditProcessNames.JobFetchProcessInitiated, "ReadOnlyFetch");
          }
          // if(location?.pathname?.toLowerCase() === "/csrview"){
            const jobResponse = await getJobFiles(token, jobId);
          
            if(jobResponse){
              if(jobResponse?.MacroFile?.toLowerCase() === "gradation"){
                listOfCalls = listOfCalls.filter((loc) => loc !== 5);
                 if (!listOfCalls.includes(4)) {
                  listOfCalls.push(4);
                }
              }
              else if(jobResponse?.MacroFile?.toLowerCase() === "csr pro"){
                listOfCalls = listOfCalls.filter((loc) => ![3,4,5,6,7,9,10,2,8].includes(loc));
                setSheetListOptionSet(["Summary Checklist"]);
              }
              setChecklistypeState(jobResponse);
            }else{
              setChecklistypeState({});
            }
          // }
          const promiseResponse = Promise.all(
            listOfCalls.map(async (e, index) => {
              if (e == 1 && location.pathname === "/xlpage") {
                const res1 = await dataRender(jobId, "Summary Checklist");
                return res1;
              }
              if (e == 2 && location.pathname === "/xlpage") {
                const res2 = await formRender(jobId, "");
                return res2;
              }
              if (e == 3 && (["1003", "1150", "1005", "1132"]?.includes(brokerId) || ["1176cgl20251029071306718", "1176cgl20260128101719215"]?.includes(jobId?.toLowerCase()))) {
                let res3 = "";
                if (location.pathname === "/csrView" || location.pathname === "/csrview") {
                  res3 = await exclusionRender(jobId, "csrExclusion");
                } else {
                  res3 = await exclusionRender(jobId, "");
                }
                return res3;
              }
              if (e == 4 && (location.pathname === "/csrView" || location.pathname === "/csrview")) {
                const res4 = await GetGradationData(jobId, location.pathname);
                return res4;
              }
              if (e == 5 && (location.pathname === "/csrView" || location.pathname === "/csrview")) {
                const res5 = await csrPolicyData(jobId, "9", "0");
                return res5;
              }
              if (e == 6 && !["1099", "1121"]?.includes(brokerId) & (location.pathname === "/csrView" || location.pathname === "/csrview")) {
                const res6 = await csrFormData(jobId);
                return res6;
              }
              if (e == 7 && (location.pathname === "/csrView" || location.pathname === "/csrview")) {
                const res7 = await ExportQac(jobId);
                return res7;
              }
              if (e == 8 && location.pathname === "/xlpage") {
                const res8 = await ExportQac(jobId);
                return res8;
              }
              if (e == 9 && location.pathname === "/xlpage") {
                const res9 = await getSheetListsInMasterData(jobId);
                return res9;
              }
              if (e == 10 && (location.pathname === "/csrView" || location.pathname === "/csrview") && renderBrokerIdsQac?.includes(brokerId)) {
                const res10 = await QACDataRender(jobId, token);
                return res10;
              }
              if (e == 11) {
                let res11 = "";
                if ((location.pathname === "/csrView" || location.pathname === "/csrview") &&
                  (["1003", "1150"]?.includes(brokerId) || jobResponse?.MacroFile?.toLowerCase() === "csr pro")) {
                  res11 = await summaryReviewChecklistRender(jobId, true);
                }
                // else {
                //   res11 = await summaryReviewChecklistRender(jobId, false);
                // }
                return res11;
              }
              if (e == 12) {
                let res12 = "";
                if ((location.pathname === "/csrView" || location.pathname === "/csrview")) {
                  // (["1099", "1121"]?.includes(brokerId))
                  res12 = await getJobFiles(token, jobId);
                }
                setChecklistypeState(res12 || []);
                // else {
                //   res11 = await summaryReviewChecklistRender(jobId, false);
                // }
                return res12;
              }
              if (e == 13 && location.pathname === "/xlpage") {
                setDocumentDetails(jobId);
              }
              if (e === 14 && location.pathname === "/xlpage") {
                GetCheckListQuestionMasterData(token, jobId);
              }
            })
          );
          promiseResponse.then((res) => {
            if (!userRes || (location.pathname === "/csrView" && userRes === sessionStorage.getItem("csrAuthUserName")) || (location.pathname === "/xlpage" && userRes === sessionStorage.getItem("userName"))) {
              updateGridAuditLog(
                jobId,
                auditProcessNames.JobFetchProcessCompleted,
                ""
              );
            } else {
              updateGridAuditLog(jobId, auditProcessNames.JobFetchProcessCompleted, "ReadOnlyFetch");
            }
            setIsValue(true);
            setIsReadonly(true);
            // setSheetRenderConfig({PolicyReviewChecklist: 'true', FormsCompare: 'false', Exclusion: 'false', QAC_not_answered_questions: 'false'});
            document.body.classList.remove("loading-indicator");
          });
          isIntialRender = false;
        });

      } else {
        isIntialRender = true;
      }
    }
    catch (error) {
      document.body.classList.remove('loading-indicator');
    }
    // finally {
    // document.body.classList.remove('loading-indicator');
    // }
  }, []);

  const updateCsrEntry = async (jobid, message, needRedirection) => {
    try {
      await updateGridAuditLog(jobid, message, window.location.href);
      if (needRedirection === true) {
        window.location.href = "/UnAuthorizedUser";
      }
    } catch (error) {
      if (needRedirection === true) {
        window.location.href = "/UnAuthorizedUser";
      }
    }
  }

  const canRenderExclusion = (brokerId) => {
    const ApplicablebrokerIds = sessionStorage.getItem("exclusionApplicableBrokerIds");
    try {
      const parsedData = ApplicablebrokerIds && ApplicablebrokerIds?.length > 0 ? JSON.parse(ApplicablebrokerIds) : [];
      return parsedData?.length > 0 && parsedData?.includes(brokerId) ? true : false;
    } catch (error) { return false }
  }

  const ComponentRenderApiFun = async (jobId) => {
    try {
      let userName = (await ComponentRenderApi(jobId, location.pathname));
      // userName['data'] = "Dispatched" 
      if ((location.pathname === "/xlpage" || location.pathname === "/csrView") && userName?.data && userName?.data === "Dispatched") {
        window.location.href = "/DispatchedJob";
      }
      const loggedinUser = sessionStorage.getItem('userName')
      if (location.pathname === "/xlpage" && userName?.data && userName?.data?.toLowerCase()?.trim() !== loggedinUser?.toLowerCase()?.trim()) {
        navigate("/Warning", { state: { userName: userName?.data } });
        return "redirected";
      }
      setDefaultSheetNameData(userName?.data);
      return userName?.data;
    } catch (error) {
      return "";
    }
  }

  const csrAuthenticationTokenApi = async () => {
    document.body.classList.add("loading-indicator");
    let url = new URL(window.location.href);
    let jobId = url?.searchParams.get("jobId") || url?.searchParams.get("jobid");
    try {
      let urlParamToken = url?.searchParams.get("token");
      const decode_UserName = jwt_decode(urlParamToken || "");
      const csrAuthUserName = decode_UserName?.preferred_username;

      if (jobId != undefined && csrAuthUserName != undefined) {
        sessionStorage.setItem("csrAuthUserName", csrAuthUserName);
        const dataForcsrValidata = {
          JobId: jobId,
          csrName: csrAuthUserName,
          token: urlParamToken
        }
        let csrView_UserName = await new Promise((resolve, reject) => {
          axios
            .post(
              `${baseUrl}/api/Authentication/csrValidate`, dataForcsrValidata, {
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
              }
            }
            )
            .then((response) => {
              if (response.data == false) {
                if (location.pathname === "/csrView" || location.pathname === "/csrview") {
                  window.location.href = "/UnAuthorizedUser";
                }
              } else {
                resolve(response.data);
              }
            })
            .catch((error) => {
              sessionStorage.setItem("csrValidateErrors", typeof error === 'object' ? JSON.stringify(error?.response || error) : error);
              reject(error);
            });
        });
      } else {
        await updateGridAuditLog(jobId, 'CsrJobValidation-Error', urlParamToken);
        if (location.pathname === "/csrView" || location.pathname === "/csrview") {
          window.location.href = "/UnAuthorizedUser";
        }
      }
    } catch (error) {
      sessionStorage.setItem("csrValidateError", error?.response?.data);
      await updateGridAuditLog(jobId, 'CsrJobValidation-Error', url?.searchParams.get("token"));
      if (location.pathname === "/csrView" || location.pathname === "/csrview") {
        window.location.href = "/UnAuthorizedUser";
      }
      return error;
    } finally {
      // document.body.classList.remove('loading-indicator');
      return "success";
    }
  };

  const getSheetListsInMasterData = async (jobId) => {
    try {
      const updatedToken = await processAndUpdateToken(token);
      token = updatedToken;
      const headers = {
        Authorization: `Bearer ${updatedToken}`,
      };
      if (jobId) {
        let GetSheetList = await new Promise((resolve, reject) => {
          axios
            .get(`${baseUrl}/api/Master/GetSheetList?jobId=${jobId}`, {
              headers,
            })
            .then((response) => {
              if (response.status !== 200) {
                reject(new Error(`HTTP error! Status: ${response.status}`));
              } else {
                resolve(response.data);
              }
            })
            .catch((error) => {
              reject(error);
            });
        });

        if (Array.isArray(GetSheetList) && GetSheetList.length > 0) {
          if (!renderBrokerIdsQac?.includes("1162")) {
            GetSheetList = GetSheetList?.filter(
              (item) => item !== "QAC not answered questions"
            );
          }
          if (jobId?.slice(0, 4) === "1176" && !["1176cgl20260128101719215"]?.includes(jobId)) {
            GetSheetList = GetSheetList?.filter((item) => item !== "Exclusions");
          }
        }
        setSheetListOptionSet(GetSheetList);
      }
    } catch (error) {
      console.error("Error:", error);
      // Set default sheet options if API fails
      setSheetListOptionSet(["Summary Checklist", "Forms Compare", "Exclusions", "QAC not answered questions"]);
      return error;
    } finally {
      return "success";
    }
  };

 const csrPolicyData = async (jobId, templateId, sheetType, pathName) => {
    try {
      setMasterData();
    } catch (error) { }
    try {
      const updatedToken = await processAndUpdateToken(token);
      token = updatedToken;

      const headers = {
        Authorization: `Bearer ${updatedToken}`,
      };

      if (jobId && templateId && sheetType) {
        const body = {
          JOBID: jobId,
          TEMPLATEID: templateId,
          SheetType: sheetType,
        };

        let csrViewPolicyData = await new Promise((resolve, reject) => {
          axios
            .get(
              `${baseUrl}/api/ProcedureData/GetChecklistDataByjobid?JOBID=${body.JOBID}&TEMPLATEID=${body.TEMPLATEID}&SheetType=${body.SheetType}`,
              { headers }
            )
            .then((response) => {
              if (response.status !== 200) {
                reject(new Error(`HTTP error! Status: ${response.status}`));
              } else {
                resolve(response.data);
              }
            })
            .catch((error) => {
              reject(error);
            });
        });
        if (csrViewPolicyData?.IsApplicable) {
          const transformFormsOnly = (dataArray) => {
                    return dataArray.map(item => {
                        const isFormsTable = !["Table 1", "Table 2", "Table 3"].includes(item.Tablename);

                        let tData = typeof item.TemplateData == 'object' ? item.TemplateData : JSON.parse(item.TemplateData);

                        if (isFormsTable && Array.isArray(tData)) {
                            tData = tData.map(row => {
                                const newRow = { ...row };
                                Object.keys(newRow).forEach(key => {
                                    if (typeof newRow[key] === 'string' && newRow[key].trim() === "Details not available in the document") {
                                        newRow[key] = "Form not attached in the document";
                                    }
                                });
                                return newRow;
                            });
                        }

                        return {
                            ...item,
                            TemplateData: tData
                        };
                    });
                };

                if (pathName === "/csrsheet") {
            const parsed_data = transformFormsOnly(csrViewPolicyData?.Response);

            const getRecordsWhichHasVariancer = (records) => {
              if (records && records.length > 0) {
                return records.map((record) => {
                  if (record.Tablename !== "Table 1") {
                    if (record.TemplateData && record.TemplateData.length > 0) {
                      const columns = Object.keys(record.TemplateData[0]);
                      const masterColumns = [
                        "Current Term Policy", "Prior Term Policy", "Binder", "Proposal", "Quote", "Application", "Schedule",
                        "Current Term Policy - Listed", "Proposal - Listed", "Binder - Listed", "Schedule - Listed",
                        "Quote - Listed", "Application - Listed", "Prior Term Policy - Listed", "Current Term Policy Listed",
                        "Prior Term Policy - Listed", "Current Term Policy Attached", "Current Term Policy - Listed"
                      ];

                      const documentColumns = columns.filter((column) => masterColumns.includes(column));

                      if (documentColumns.length > 0) {
                        let templateDataCopy = [...record.TemplateData]; // Create a copy of TemplateData to avoid mutation

                        // Filter TemplateData based on variance condition
                        templateDataCopy = templateDataCopy.filter((tdcr) => {
                          let hasVariance = false;
                          documentColumns.forEach((dclms) => {
                            if (tdcr[dclms] &&
                              !tdcr[dclms].toLowerCase().includes("Form not attached in the document") &&
                              !tdcr[dclms].toLowerCase().includes("details not available in the document") &&
                              !tdcr[dclms].toLowerCase().includes("matched")) {
                              hasVariance = true;
                            }
                          });
                          return hasVariance;
                        });

                        // Update TemplateData with the filtered data
                        record.TemplateData = templateDataCopy;
                      }
                    }
                  }
                  return record;
                });
              }
              return records;
            };

            let filtered_data = getRecordsWhichHasVariancer(parsed_data);
            filtered_data = filtered_data?.filter((item) => !(item?.Tablename !== "Table 1" && item?.TemplateData && item?.TemplateData.length === 0));
            filtered_data = filtered_data.map((item) => {
              item.TemplateData = JSON.stringify(item.TemplateData);
              return item;
            });
            // const inputData = getRecordsWhichHasVariancer(parsed_data);
            setCsrChecklistData(filtered_data);
          } else {
            const simpleParsed = transformFormsOnly(csrViewPolicyData?.Response).map(item => ({
                        ...item,
                        TemplateData: JSON.stringify(item.TemplateData)
                    }));
                    setCsrChecklistData(simpleParsed);
                }
            }
      }
    } catch (error) {
      console.error("Error:", error);
      return error;
    }
  };

  const csrFormData = async (jobId) => {
    try {
      const updatedToken = await processAndUpdateToken(token);
      token = updatedToken;

      const headers = {
        Authorization: `Bearer ${updatedToken}`,
      };

      if (jobId) {
        const body = {
          JOBID: jobId,
        };

        let csrViewFormData = await new Promise((resolve, reject) => {
          axios
            .get(
              `${baseUrl}/api/ProcedureData/GetGridChecklistFormData?JOBID=${body.JOBID}`,
              { headers }
            )
            .then((response) => {
              if (response.status !== 200) {
                reject(new Error(`HTTP error! Status: ${response.status}`));
              } else {
                resolve(response.data);
              }
            })
            .catch((error) => {
              reject(error);
            });
        });
        if (csrViewFormData?.IsApplicable) {
          if (
            csrViewFormData?.Response &&
            csrViewFormData?.Response?.length > 0
          ) {
            csrViewFormData?.Response.map((e, index) => {
              if (index === 2) {
                let matechedSectionData =
                  typeof e?.TemplateData === "string"
                    ? JSON.parse(e?.TemplateData)
                    : e?.TemplateData;
                if (matechedSectionData && matechedSectionData?.length > 0) {
                  matechedSectionData = matechedSectionData.map(
                    ({ "Document Viewer": _, ...rest }) => rest
                  );
                }
                e["TemplateData"] = JSON.stringify(matechedSectionData);
              }
              return e;
            });
          }
          setCsrFormsData(csrViewFormData?.Response);
        }
      } else {
        throw new Error(
          "Missing required parameters: jobId, templateId, or sheetType"
        );
      }
    } catch (error) {
      console.error("Error:", error);
      return error;
    }
  };

  const TARGET_TABLES = [
    "Table 2",
    "Table 3",
    "Table 4",
    "Table 5",
    "Table 6",
    "Table 7"
  ];

  const getQuestionsToFilterByHighCS = (orderedData, minCellLockScore = 95) => {
    if (!Array.isArray(orderedData)) return new Set();

    const header = orderedData.find(d => d?.Tablename === "JobHeader");
    if (!header?.IsCosmosFlag) {
      return new Set();
    }
    const cdData = orderedData.find(d => d?.Tablename === "JobCoverages");
    const CS_THRESHOLD = parseFloat(minCellLockScore) || 95;

    const isArJob = Boolean(header?.IsArJob);
    const isSsdJob = Boolean(header?.IsSsdJob);
    const hasEnableCellLock = Boolean(header?.EnableCellLock);
    const isMsdJob = !isArJob && !isSsdJob;
    const hasEndorsement = Boolean(header?.HasEndorsement);
    const IslobSplit = Boolean(cdData?.isMultipleLobSplit);

    const hasNotAllowedColumns = Array.isArray(cdData?.TemplateData) && cdData.TemplateData.some(f => ["proposal", "application", "schedule"].includes(f?.toLowerCase()?.trim()));
    if (hasEndorsement || ((isSsdJob || isMsdJob) && hasNotAllowedColumns) || !hasEnableCellLock || notToFilterBrokers.includes(header.jobid.slice(0, 4))) {
      return new Set();
    }

    const questionTracker = {};

    orderedData.forEach(table => {
      if (!TARGET_TABLES.includes(table?.Tablename) || !Array.isArray(table?.TemplateData) || (table?.Tablename === "Table 3" && IslobSplit)) return;

      table.TemplateData.forEach(row => {
        let questionKey = row?.ChecklistQuestions?.toLowerCase()?.trim()?.slice(0, 3) || "";

        if (!questionKey) return;

        // Table-5 PT1 collision fix
        if (table.Tablename === "Table 5" && questionKey === "pt1") {
          questionKey = "pt2";
        }

        if (!questionTracker[questionKey]) {
          questionTracker[questionKey] = {
            isAllMatched: true,
            hasNumericCs: false,
            csAboveThreshold: true,
            hasDNA: false
          };
        }

        Object.entries(row).forEach(([col, value]) => {
          // if (col === "ChecklistQuestions") return;
          if (!getCsRespectiveColumn(col)) return;


          // DNA check
          if (typeof value === "string" && value.toLowerCase().includes("details not available")) {
            questionTracker[questionKey].hasDNA = true;
            return;
          }
          if (!value || typeof value !== "string" || value.toLowerCase().trim() !== "matched") {
            questionTracker[questionKey].isAllMatched = false;
          }

          const parsed = parseFloat(value);
          const isNumeric = !isNaN(parsed);

          if (isNumeric) {
            let csValue = parseFloat(value);
            questionTracker[questionKey].hasNumericCs = true;

            // TABLE 5 – PT1 SPECIAL FIX
            if (
              table.Tablename === "Table 5" &&
              row?.ChecklistQuestions?.toLowerCase().trim().slice(0, 3) === "pt1" &&
              col === "CurrentTermPolicyListedCs"
            ) {
              csValue = parseFloat(row["CurrentTermPolicyListedCs1"]);
            }

            if (isNaN(csValue) || csValue < CS_THRESHOLD) {
              questionTracker[questionKey].csAboveThreshold = false;
            }

            return;
          }
        });
      });
    });

    return new Set(
      Object.entries(questionTracker)
        .filter(([_, v]) => (!v.hasDNA && (v.isAllMatched || (v.csAboveThreshold))))
        .map(([q]) => q)
    );
  };

  const dataRender = async (jobId, processName) => {
    try {
      setMasterData();
    } catch (error) { }
    try {
      if (processName == "Summary Checklist") {
        // const lineItemCount = await JobPRTotalCount(jobId);
        // if (lineItemCount && lineItemCount > 2000) {
        //   sessionStorage.setItem("JobPRTotalCount", lineItemCount);
        //   reference?.current?.showSnackbar(
        //     `This job has ${lineItemCount} line items. Please be Patience, the data will be rendered soon.`,
        //     "success",
        //     true
        //   );
        // }
        const updatedToken = await processAndUpdateToken(token);
        token = updatedToken;
        const headers = { Authorization: `Bearer ${updatedToken}` };
        let jobResponse;
        let csConfigData = [];
        try {
          csConfigData = await GetConfidenceScoreConfig(jobId);
          setConfidenceScoreConfig(csConfigData);
        } catch (error) {
          setConfidenceScoreConfig(confidenceScoreConfigStaticData);
        }
          let overrideConfig = null;
        try {
          overrideConfig = await getOverrideConfig(jobId);
        } catch (err) {
          overrideConfig = null;
        }
        setOverrideConfig(overrideConfig);
        if (jobId) {
          const listOfCalls = [2, 3, 4, 5, 6, 7, 8];
          const headerData = await JobHeaderData(jobId, token);
          let responseDataSet = await Promise.all(
            listOfCalls.map(async (e, index) => {
              // if(e === 1){
              //   document.body.classList.add( 'loading-indicator' );
              //   return { e, data: await JobHeaderData( jobId, token ) };
              // } else
              if (e === 2) {
                document.body.classList.add("loading-indicator");
                return { e, data: await JobCDData(jobId, token) };
              } else if (e === 3) {
                document.body.classList.add("loading-indicator");
                return { e, data: await JobJCData(jobId, token) };
              } else if (e === 4) {
                document.body.classList.add("loading-indicator");
                return { e, data: await JobF1Data(jobId, token) };
              } else if (e === 5) {
                document.body.classList.add("loading-indicator");
                return { e, data: await JobF2Data(jobId, token) };
              } else if (e === 6) {
                document.body.classList.add("loading-indicator");
                return { e, data: await JobF3Data(jobId, token) };
              } else if (e === 7) {
                document.body.classList.add("loading-indicator");
                return { e, data: await JobF4Data(jobId, token) };
              } else if (e === 8) {
                document.body.classList.add("loading-indicator");
                return { e, data: await JobConfigData(jobId, token) };
              }
            })
          );
          responseDataSet = [{ e: 1, data: headerData }, ...responseDataSet];
          let jobResponse = [];
          const listOfCallsSub = [1, 2, 3, 4, 5, 6, 7, 8];
          listOfCallsSub.forEach((f) => {
            if (f != 8) {
              const findData = responseDataSet.find((item) => item?.e === f);
              jobResponse.push(findData?.data);
            } else {
              const find8Data = responseDataSet.find((item) => item?.e === f);
              jobResponse = [...jobResponse, ...find8Data?.data];
            }
          });

          const requiredDataSet = [
            "Table 1",
            "Table 2",
            "Table 3",
            "Table 4",
            "Table 5",
            "Table 6",
            "Table 7",
          ];

          const Header_Config_Data = jobResponse?.find((jrf) => jrf?.Tablename && jrf?.Tablename === "JobHeader");
          let needDnaCheck = true;
          let needFormsMatchedCheck = true;

          if (!Header_Config_Data?.IsArJob) {
            const commonDeclarationData = jobResponse?.find((jrf) => jrf?.Tablename && jrf?.Tablename?.toLowerCase() === "jobcommondeclaration");
            if (!commonDeclarationData || (commonDeclarationData && (commonDeclarationData?.TemplateData?.includes("Application") || commonDeclarationData?.TemplateData?.includes("Epic")))) {
              needDnaCheck = false;
            }
          }

          let orderedData = jobResponse.map((e) => {
            if (
              e?.TemplateData &&
              e?.TemplateData?.length > 0 &&
              (e?.Tablename == "Table 2" || e?.Tablename == "Table 3")
            ) {
              const hasColumnId = e.TemplateData.filter(
                (f) => f?.Columnid == null || f?.Columnid == ""
              );
              if (hasColumnId && hasColumnId?.length == 0) {
                e.TemplateData = e.TemplateData.sort(
                  (a, b) => parseInt(a.Columnid) - parseInt(b.Columnid)
                );
              }
              if (e?.Tablename == "Table 3") {
                e.TemplateData = e?.TemplateData?.filter(
                  (f) => !f?.IsDataForSp
                );
              }
            }

            // DNA CHECK ADDED FOR AR & SSD SCENARIOS
            if (needDnaCheck && Header_Config_Data && Header_Config_Data?.EnableCS && e?.Tablename !== "Table 1" && requiredDataSet?.includes(e?.Tablename)) {
              if (e?.TemplateData && e?.TemplateData?.length > 0) {
                const app_config_data = jobResponse?.find((jrf) => jrf?.Tablename && jrf?.Tablename === getRespectiveTableName(e?.Tablename));
                const master_col_data = getColumnsAvailableInMasterOrder(app_config_data?.TemplateData, e?.Tablename);
                if (app_config_data && app_config_data?.TemplateData?.length > 0) {
                  if ((Header_Config_Data?.IsArJob || Header_Config_Data?.IsSsdJob) && master_col_data?.length === 2) {
                    const ct_key = master_col_data[0];
                    const pt_key = master_col_data[1];

                    if (ct_key && pt_key) {
                      e.TemplateData = e?.TemplateData?.map((val) => {
                        if (val[ct_key] && val[ct_key]?.trim()?.toLowerCase() === "details not available in the document" &&
                          val[pt_key] && val[pt_key]?.trim()?.toLowerCase() === "details not available in the document"
                        ) {
                          // DNA ignored for "LMT","DE1","ULM", Requested by **MALLI** ON 25-AUG-2025
                          if (e?.Tablename === "Table 3" && val["ChecklistQuestions"] && ["LMT", "DE1", "ULM"]?.includes(val["ChecklistQuestions"]?.trim()?.toUpperCase()?.slice(0, 3))) {
                            val[getCsRespectiveColumn(ct_key)] = '0';
                            val[getCsRespectiveColumn(pt_key)] = '0';
                          } else {
                            val[getCsRespectiveColumn(ct_key)] = '100';
                            val[getCsRespectiveColumn(pt_key)] = '100';
                          }
                        }

                        // if(val[ct_key] && val[ct_key]?.trim()?.toLowerCase() !== "details not available in the document" && 
                        //     val[pt_key] && val[pt_key]?.trim()?.toLowerCase() === "details not available in the document"
                        //   ){
                        //     const cs_col_value = val[getCsRespectiveColumn(ct_key)];
                        //     if(cs_col_value?.trim() !== "" && cs_col_value?.trim()?.toLowerCase() !== "details not available in the document" && cs_col_value){
                        //       if(parseFloat(cs_col_value) >= 95){
                        //         val[getCsRespectiveColumn(pt_key)] = '100';
                        //       }
                        //     }
                        // }

                        // if(val[ct_key] && val[ct_key]?.trim()?.toLowerCase() === "details not available in the document" && 
                        //     val[pt_key] && val[pt_key]?.trim()?.toLowerCase() !== "details not available in the document"
                        //   ){
                        //     const cs_col_value = val[getCsRespectiveColumn(pt_key)];
                        //     if(cs_col_value?.trim() !== "" && cs_col_value?.trim()?.toLowerCase() !== "details not available in the document" && cs_col_value){
                        //       if(parseFloat(cs_col_value) >= 95){
                        //         val[getCsRespectiveColumn(ct_key)] = '100';
                        //       }
                        //     }
                        // }
                        return val;
                      });
                    }

                  } else if ((!Header_Config_Data?.IsArJob && !Header_Config_Data?.IsSsdJob) && master_col_data?.length === 3) {
                    const ct_key = master_col_data[0];
                    const pt_key = master_col_data[1];
                    const pt_key1 = master_col_data[2];

                    if ((ct_key && ["CurrentTermPolicy", "CurrentTermPolicyListed"]?.includes(ct_key)) && (pt_key && ["Quote", "Binder", "Application", "QuoteListed", "ApplicationListed", "BinderListed"]?.includes(pt_key)) && (pt_key1 && ["Quote", "Binder", "Application", "QuoteListed", "ApplicationListed", "BinderListed"]?.includes(pt_key1))) {
                      e.TemplateData = e?.TemplateData?.map((val) => {
                        if (val[ct_key] && val[ct_key]?.trim()?.toLowerCase() === "details not available in the document" &&
                          val[pt_key] && val[pt_key]?.trim()?.toLowerCase() === "details not available in the document" &&
                          val[pt_key1] && val[pt_key1]?.trim()?.toLowerCase() === "details not available in the document"
                        ) {
                          if (e?.Tablename === "Table 3" && val["ChecklistQuestions"] && ["LMT", "DE1", "ULM"]?.includes(val["ChecklistQuestions"]?.trim()?.toUpperCase()?.slice(0, 3))) {
                            val[getCsRespectiveColumn(ct_key)] = '0';
                            val[getCsRespectiveColumn(pt_key)] = '0';
                            val[getCsRespectiveColumn(pt_key1)] = '0';
                          } else {
                            val[getCsRespectiveColumn(ct_key)] = '100';
                            val[getCsRespectiveColumn(pt_key)] = '100';
                            val[getCsRespectiveColumn(pt_key1)] = '100';
                          }
                        }
                        return val;
                      });
                    }

                  }
                  // else if(Header_Config_Data?.IsSsdJob && master_col_data?.length === 2){
                  //   const ct_key = app_config_data?.TemplateData?.find((acd) => acd?.toLowerCase()?.includes('current'))
                  //   const pt_key = app_config_data?.TemplateData?.find((acd) => acd?.toLowerCase()?.includes('prior'))
                  //   const reference_key = (app_config_data?.TemplateData?.find((acd) => acd?.toLowerCase()?.includes('quote')) || 
                  //                           app_config_data?.TemplateData?.find((acd) => acd?.toLowerCase()?.includes('binder')));

                  //   if(ct_key && pt_key && reference_key){

                  //   }

                  // }
                }
              }
            }

            // Forms Matched Scenario Check:
            const possible_forms_tables = ["Table 4", "Table 5", "Table 6", "Table 7"];
            if (needFormsMatchedCheck && Header_Config_Data && Header_Config_Data?.EnableCS && possible_forms_tables?.includes(e?.Tablename)) {
              if (e?.TemplateData && e?.TemplateData?.length === 1) {
                const app_config_data = jobResponse?.find((jrf) => jrf?.Tablename && jrf?.Tablename === getRespectiveTableName(e?.Tablename));
                const master_col_data = getColumnsAvailableInMasterOrder(app_config_data?.TemplateData, e?.Tablename);
                e?.TemplateData?.map((form_data) => {
                  let matchedCount = 0;
                  master_col_data?.forEach((mcd) => {
                    if (form_data[mcd] && form_data[mcd]?.trim()?.toLowerCase() === "matched") {
                      matchedCount += 1;
                    }
                  });
                  if (matchedCount === master_col_data?.length) {
                    master_col_data?.forEach((mcd) => {
                      const cs_key = getCsRespectiveColumn(mcd);
                      if (cs_key) {
                        form_data[cs_key] = "100";
                      }
                    });
                  }
                  return form_data;
                });
              }
            }
            return e;
          });

          // if(sessionStorage.getItem('userName')?.toLowerCase() === "ramu_s@exdion.com"){
          orderedData = orderedData?.map((f) => {
            if (f?.Tablename !== "Table 1" && requiredDataSet?.includes(f?.Tablename)) {
              if (f?.TemplateData?.length > 0) {
                if (f?.Tablename === "Table 2" || f?.Tablename === "Table 3") {
                  const questionMapping = f?.TemplateData?.map((e) => {
                    return {
                      columnId: e?.Columnid,
                      shortQuestion: e?.ChecklistQuestions?.trim()?.toLowerCase()?.slice(0, 3),
                    };
                  });
                  const uniqueObjects = questionMapping.filter(
                    (item, index, self) =>
                      index ===
                      self.findIndex(
                        (t) => t.shortQuestion === item.shortQuestion
                      )
                  );

                  // console.log(uniqueObjects);
                  let newTemplateData_ordered = [];

                  if (uniqueObjects?.length > 0) {
                    const colIdSet = uniqueObjects?.map((e) => e?.columnId);
                    let colIdSetUnique = Array.from(new Set(colIdSet));

                    if (colIdSetUnique?.length > 0) {
                      if (typeof colIdSetUnique[0] === 'string') {
                        colIdSetUnique = colIdSetUnique?.map(Number)?.sort((a, b) => a - b).map(String);
                      } else {
                        colIdSetUnique = colIdSetUnique?.sort((a, b) => a - b);
                      }
                    }

                    // console.log(colIdSetUnique);

                    colIdSetUnique?.forEach((uid) => {
                      const quesObjs = uniqueObjects?.filter(uo => uo?.columnId === uid);
                      // console.log(uid);
                      // console.log(quesObj);
                      quesObjs.forEach((quesObj) => {
                        let dataToOrder = f?.TemplateData?.filter((td) => td?.ChecklistQuestions?.trim()?.toLowerCase()?.slice(0, 3) === quesObj?.shortQuestion?.trim()?.toLowerCase());

                        if (dataToOrder?.length > 1) {
                          const app_config_data = jobResponse?.find((jrf) => jrf?.Tablename && jrf?.Tablename === getRespectiveTableName(f?.Tablename));
                          const master_col_data = getColumnsAvailableInMasterOrder(app_config_data?.TemplateData, f?.Tablename);
                          if (master_col_data?.length > 0) {
                            master_col_data?.forEach((mcd) => {
                              // Column based data filter for ordering the data;
                              const col_based_data = dataToOrder?.filter((dto) =>
                                dto[mcd] && dto[mcd]?.trim()?.toLowerCase() !== 'details not available in the document' &&
                                dto[mcd]?.trim()?.toLowerCase() !== 'matched'
                              );

                              if (col_based_data?.length > 0) {
                                dataToOrder = dataToOrder?.filter((dto) =>
                                  !(dto[mcd] && dto[mcd]?.trim()?.toLowerCase() !== 'details not available in the document' &&
                                    dto[mcd]?.trim()?.toLowerCase() !== 'matched')
                                );
                                let temp_data_holder = col_based_data?.map((cbd) => { return { ...cbd, PNO: getTextByRequirement(cbd[mcd], "getPage", mcd) } });

                                if (temp_data_holder.length > 0 && temp_data_holder[0]?.PNO && typeof temp_data_holder[0]?.PNO === 'string') {
                                  temp_data_holder = temp_data_holder.sort((a, b) => (Number(a.PNO) ?? Infinity) - (Number(b.PNO) ?? Infinity));
                                } else {
                                  temp_data_holder = temp_data_holder.sort((a, b) => (a.PNO ?? Infinity) - (b.PNO ?? Infinity));
                                }
                                temp_data_holder = temp_data_holder.map(({ PNO, ...rest }) => rest);
                                console.log(temp_data_holder);
                                newTemplateData_ordered = [...newTemplateData_ordered, ...temp_data_holder];
                              }
                            });

                            if (dataToOrder?.length > 0) {
                              newTemplateData_ordered = [...newTemplateData_ordered, ...dataToOrder];
                            }
                          } else {
                            newTemplateData_ordered = [...newTemplateData_ordered, ...dataToOrder];
                          }
                        } else {
                          newTemplateData_ordered = [...newTemplateData_ordered, ...dataToOrder];
                        }
                      });
                    });

                    if (newTemplateData_ordered?.length > 0) {
                      f.TemplateData = newTemplateData_ordered;
                    }
                  }
                } else {
                  let newTemplateData_ordered = [];
                  let dataToOrder = f?.TemplateData;

                  if (dataToOrder?.length > 1) {
                    const app_config_data = jobResponse?.find((jrf) => jrf?.Tablename && jrf?.Tablename === getRespectiveTableName(f?.Tablename));
                    const master_col_data = getColumnsAvailableInMasterOrder(app_config_data?.TemplateData, f?.Tablename);
                    if (master_col_data?.length > 0) {
                      master_col_data?.forEach((mcd) => {
                        // Column based data filter for ordering the data;
                        const col_based_data = dataToOrder?.filter((dto) =>
                          dto[mcd] && dto[mcd]?.trim()?.toLowerCase() !== 'details not available in the document' &&
                          dto[mcd]?.trim()?.toLowerCase() !== 'matched'
                        );

                        if (col_based_data?.length > 0) {
                          dataToOrder = dataToOrder?.filter((dto) =>
                            !(dto[mcd] && dto[mcd]?.trim()?.toLowerCase() !== 'details not available in the document' &&
                              dto[mcd]?.trim()?.toLowerCase() !== 'matched')
                          );
                          let temp_data_holder = col_based_data?.map((cbd) => { return { ...cbd, PNO: getTextByRequirement(cbd[mcd], "getPage", mcd) } });

                          if (temp_data_holder.length > 0 && temp_data_holder[0]?.PNO && typeof temp_data_holder[0]?.PNO === 'string') {
                            temp_data_holder = temp_data_holder.sort((a, b) => (Number(a.PNO) ?? Infinity) - (Number(b.PNO) ?? Infinity));
                          } else {
                            temp_data_holder = temp_data_holder.sort((a, b) => (a.PNO ?? Infinity) - (b.PNO ?? Infinity));
                          }
                          temp_data_holder = temp_data_holder.map(({ PNO, ...rest }) => rest);
                          console.log(temp_data_holder);
                          newTemplateData_ordered = [...newTemplateData_ordered, ...temp_data_holder];
                        }
                      });

                      if (dataToOrder?.length > 0) {
                        newTemplateData_ordered = [...newTemplateData_ordered, ...dataToOrder];
                      }
                    } else {
                      newTemplateData_ordered = [...newTemplateData_ordered, ...dataToOrder];
                    }
                  } else {
                    newTemplateData_ordered = [...newTemplateData_ordered, ...dataToOrder];
                  }

                  if (newTemplateData_ordered?.length > 0) {
                    f.TemplateData = newTemplateData_ordered;
                  }
                }
              }
            }
            return f;
          });
          // }          

          const jobid = ["1099prp20260331065356022", "1099cgl20260323130228795"];
          orderedData = orderedData
          ?.filter(f => !(jobid?.includes(f.jobid) && f.Tablename === "Table 4"))
          ?.map((f) => {
            // your existing logic
            return f;
          });
          setJobData(orderedData);
          //updating the OBSERVATION AND PAGENUMBER COLUMNS ON RENDERING ****BEGIN****

          const masterDataForColumns = orderedData.filter(
            (f) => f && f?.Tablename && !requiredDataSet?.includes(f?.Tablename)
          );
          orderedData.map((item, oIndex) => {
            if (
              item &&
              item?.Tablename &&
              requiredDataSet?.includes(item?.Tablename)
            ) {
              if (item?.TemplateData && item?.TemplateData?.length > 0) {
                let applicableColumns = [];
                let appilcableColumnMaster = [];
                if (item?.Tablename === "Table 1") {
                  appilcableColumnMaster = masterDataForColumns.find(
                    (f) => f?.Tablename === "JobHeader"
                  );
                } else if (item?.Tablename === "Table 2") {
                  appilcableColumnMaster = masterDataForColumns.find(
                    (f) => f?.Tablename === "JobCommonDeclaration"
                  );
                } else if (item?.Tablename === "Table 3") {
                  appilcableColumnMaster = masterDataForColumns.find(
                    (f) => f?.Tablename === "JobCoverages"
                  );
                } else if (item?.Tablename === "Table 4") {
                  appilcableColumnMaster = masterDataForColumns.find(
                    (f) => f?.Tablename === "Tbl_ChecklistForm1"
                  );
                } else if (item?.Tablename === "Table 5") {
                  appilcableColumnMaster = masterDataForColumns.find(
                    (f) => f?.Tablename === "Tbl_ChecklistForm2"
                  );
                } else if (item?.Tablename === "Table 6") {
                  appilcableColumnMaster = masterDataForColumns.find(
                    (f) => f?.Tablename === "Tbl_ChecklistForm3"
                  );
                } else if (item?.Tablename === "Table 7") {
                  appilcableColumnMaster = masterDataForColumns.find(
                    (f) => f?.Tablename === "Tbl_ChecklistForm4"
                  );
                }

                if (
                  item?.Tablename !== "Table 1" &&
                  appilcableColumnMaster?.TemplateData
                ) {
                  const columnDetails = isARType(
                    item.TemplateData[0],
                    item?.Tablename
                  );
                  let orderedColumns = getColumnsAvailableInMasterOrder(
                    appilcableColumnMaster?.TemplateData,
                    item?.Tablename
                  );
                  if (orderedColumns && orderedColumns?.length > 0) {
                    item.TemplateData = item.TemplateData.map((e) => {
                      let questionCode =
                        e?.ChecklistQuestions == null || undefined
                          ? ""
                          : e?.ChecklistQuestions.trim().slice(0, 2);
                      if (e?.ChecklistQuestions?.trim()?.slice(0, 3)?.toLowerCase() === "dex") {
                        questionCode = "DX";
                      }
                      let observationText = "";
                      let pageText = "";
                      let originalColumnData = "";
                      orderedColumns.forEach((column) => {
                        const columnKey = getObservationKey(
                          column,
                          item?.Tablename
                        );
                        if (e[column]) {
                          originalColumnData = e[column];
                          let columnDataText = e[column];
                          if (
                            columnDataText &&
                            columnDataText?.toLowerCase()?.trim() !=
                            "matched" &&
                            !columnDataText
                              ?.toLowerCase()
                              ?.includes(
                                "details not available in the document"
                              )
                          ) {
                            columnDataText =
                              splitPageKekFromTextForDataRendering(
                                columnDataText
                              );
                            observationText +=
                              columnKey + columnDataText + " ~~ ";
                          } else if (observationText != "") {
                            observationText +=
                              columnKey + "NO RECORDS" + " ~~ ";
                          }
                        } else {
                          observationText += columnKey + "NO RECORDS" + " ~~ ";
                        }
                        //page number updation
                        const columnPageKeyCode = getPageKey(
                          column,
                          item?.Tablename,
                          originalColumnData
                        );
                        if (columnPageKeyCode) {
                          const pageNumber = getTextByRequirement(
                            originalColumnData,
                            "getPage",
                            column
                          );
                          originalColumnData = originalColumnData?.replace(
                            /\s+/g,
                            " "
                          );
                          if (originalColumnData && originalColumnData?.trim()?.toLowerCase() !== "matched") {
                            if (
                              originalColumnData &&
                              originalColumnData
                                ?.toLowerCase()
                                ?.includes("endorsement page #")
                            ) {
                              pageText +=
                                columnPageKeyCode?.trim() +
                                "E" +
                                questionCode?.trim() +
                                ":" +
                                pageNumber +
                                " ~~ ";
                            } else {
                              pageText +=
                                columnPageKeyCode?.trim() +
                                questionCode?.trim() +
                                ":" +
                                pageNumber +
                                " ~~ ";
                            }
                          }
                        }
                      });
                      e["Observation"] = observationText;
                      if (observationText != "") {
                        e["PageNumber"] = pageText;
                      } else {
                        e["PageNumber"] = "";
                      }
                      return e;
                    });
                  }
                }
              }
              return item;
            }
          });
          //updating the OBSERVATION AND PAGENUMBER COLUMNS ON RENDERING ****END****
          let EnableExclusionCellLockVlaue = true;
          orderedData = orderedData?.map((e) => {
            if (e.Tablename === "JobHeader" && e?.EnableCS) {
              const usr_name = sessionStorage.getItem("userName")?.toLowerCase();
              let sqCodes = [];

              // --- Try to parse MetaData if present ---
              let parsedData = null;
              if (e?.MetaData && e.MetaData.trim() !== "") {
                try {
                  parsedData = JSON.parse(e.MetaData);
                } catch (err) {
                  console.error("Invalid MetaData JSON:", err);
                }
              }

              // --- Check if MetaData applies for this user ---
              const metaUserMatch =
                parsedData?.UserName?.toLowerCase()?.includes(usr_name);

              if (parsedData && parsedData?.QuestionCode?.length > 0 && metaUserMatch) {
                sqCodes = parsedData.QuestionCode.toLowerCase().split(",");
              }

              // --- Static STP codes ---
              if (e?.IsRedStp) {
                const redStpCodes = ["ni1", "lmt", "de1", "ulm", "ie1"];
                sqCodes = [...sqCodes, ...redStpCodes];
              }

              // --- Apply codes if any exist ---
              if (sqCodes.length > 0) {
                sqCodes = sqCodes.map((code) => code.trim().toLowerCase());

                setSqCodesState(sqCodes);

                e.StpMappings = e.StpMappings.filter(
                  (f) => !sqCodes.includes(f?.ShortQuestion?.trim()?.toLowerCase())
                );
              }
            }

            if (e.Tablename === "JobHeader") {
              EnableExclusionCellLockVlaue = e?.EnableExclusionCellLock;
            }

            return e;
          });
          // const header_data = orderedData?.find((f) => f.Tablename === "JobHeader");

          if (Header_Config_Data && Header_Config_Data?.EnableCS && Header_Config_Data?.EnableCellLock) {
            // const header_master_data = orderedData?.filter((f) =>
            //   ["JobCommonDeclaration", "JobCoverages", "Tbl_ChecklistForm1", "Tbl_ChecklistForm2", "Tbl_ChecklistForm3", "Tbl_ChecklistForm4"]?.includes(f?.Tablename)
            // );
            const minCellLockScore = csConfigData?.find(csc => csc?.Key === "MinLockCellScore")?.Value;
            orderedData = orderedData?.map((o_items) => {
              if (["Table 2", "Table 3", "Table 4", "Table 5", "Table 6", "Table 7"]?.includes(o_items?.Tablename)) {
                const column_master = orderedData?.find(f => f?.Tablename === getRespectiveTableName(o_items?.Tablename));
                if (column_master && column_master?.TemplateData?.length > 0) {
                  o_items.TemplateData.map((data_sets) => {
                    column_master?.TemplateData?.forEach((col) => {
                      const feed_back_col = getFeedBackRespectiveColumn(col);
                      if (feed_back_col) {
                        // data_sets.map((data_set) => {
                        let cs_column = getFeedBackRespectiveColumn(feed_back_col);
                        if (o_items?.Tablename === "Table 5" && data_sets["ChecklistQuestions"] && data_sets["ChecklistQuestions"]?.trim()?.slice(0, 3)?.toLowerCase() === "pt1" && feed_back_col === "CtListedFeedback") {
                          cs_column = "CurrentTermPolicyListedCs1";
                        }
                        if (data_sets[cs_column] && parseFloat(data_sets[cs_column]) >= (minCellLockScore ? parseFloat(minCellLockScore) : 95) && !data_sets[feed_back_col]) {
                          data_sets[feed_back_col] = "Correct - Locked";
                        }
                        return data_sets;
                        // })
                      }
                    });
                    return data_sets;
                  })
                }
              }
              return o_items;
            })
          }
          console.log("orderedData", orderedData);

          const currentUser = sessionStorage.getItem("userName")?.toLowerCase() || "";
          let unlockedQuestionCodes = [];
          let unlockedForUser = "";

          const headerRow = orderedData.find(t => t?.Tablename === "JobHeader");

          if (headerRow?.MetaData) {
            try {
              const meta = JSON.parse(headerRow.MetaData);

              if (meta?.UserName) {
                unlockedForUser = meta.UserName.toLowerCase().trim();
              }

              if (meta?.QuestionCode) {
                unlockedQuestionCodes = meta.QuestionCode
                  .toLowerCase()
                  .split(",")
                  .map(q => q.trim());
              }
            } catch (e) {
              console.error("MetaData parsing error:", e);
            }
          }

          const allowUserOverride = currentUser && unlockedForUser && currentUser === unlockedForUser;

          const questionsToRemove = getQuestionsToFilterByHighCS(orderedData);

          const app_congig_headertbl = jobResponse?.find(e => e?.Tablename == "JobHeader");

          // const effectiveQuestionsToRemove = allowUserOverride && unlockedQuestionCodes?.length > 0 ? Array.from(questionsToRemove)?.filter(q => !unlockedQuestionCodes.includes(q)) : Array.from(questionsToRemove);
          let effectiveQuestionsToRemove = Array.from(questionsToRemove);

          if (allowUserOverride && unlockedQuestionCodes?.length > 0) {
            effectiveQuestionsToRemove = effectiveQuestionsToRemove.filter(
              q => !unlockedQuestionCodes.includes(q)
            );
          }

          if (headerRow?.IsRedStp) {
            const redStpCodes = ["ni1", "lmt", "de1", "ulm", "ie1"];
            effectiveQuestionsToRemove = effectiveQuestionsToRemove.filter(
              q => !redStpCodes.includes(q)
            );
          }

          const restrictedQuestionCodes = ["cl1", "ca1", "pt1", "ca2", "pt2"];

          if (restrictedQuestionCodes?.length > 0) {
            effectiveQuestionsToRemove = effectiveQuestionsToRemove.filter(
              q => !restrictedQuestionCodes.includes(q)
            );
          }
          
          if(app_congig_headertbl?.IsArJob == false && app_congig_headertbl?.IsSsdJob == false) {  // if it is MSD job remove and unhide all tables
             effectiveQuestionsToRemove = [];
          }

          if(app_congig_headertbl?.IsRedStp == false) {  // if it is GREEN job remove and unhide forms questions
             effectiveQuestionsToRemove = effectiveQuestionsToRemove.filter(
              q => !restrictedQuestionCodes.includes(q)
            );
          }

          const filteredChecklistDataMaster = [];
          if (effectiveQuestionsToRemove?.length > 0) {
            const updatedChecklistData = orderedData.map(o_items => {
              if (!TARGET_TABLES.includes(o_items?.Tablename) || !Array.isArray(o_items?.TemplateData)
              ) {
                return {
                  ...o_items,
                  FilteredData: o_items.TemplateData
                };
              }
              
              let templateDataFiltered = o_items.TemplateData.filter(row => {
                let key = row?.ChecklistQuestions ? row.ChecklistQuestions.toLowerCase().trim().slice(0, 3) : "";
                key = o_items.Tablename === "Table 5" && key === "pt1" ? "pt2" : key;
                return !effectiveQuestionsToRemove.includes(key);
              });

              if (["Table 4", "Table 5", "Table 6", "Table 7"].includes(o_items?.Tablename)) {
                templateDataFiltered = templateDataFiltered.map(row => {
                  const updatedRow = { ...row };

                  Object.keys(updatedRow).forEach(col => {
                    if (
                      typeof updatedRow[col] === "string" &&
                      updatedRow[col].trim().toLowerCase() ===
                      "details not available in the document"
                    ) {
                      updatedRow[col] = "Form not attached in the document";
                    }
                  });

                  return updatedRow;
                });
              }
              
              let filteredDataFromTemplateData = o_items?.TemplateData?.filter(row => {
                let key = row?.ChecklistQuestions ? row.ChecklistQuestions.toLowerCase().trim().slice(0, 3) : "";
                key = o_items.Tablename === "Table 5" && key === "pt1" ? "pt2" : key;
                return effectiveQuestionsToRemove.includes(key);
              });

              filteredDataFromTemplateData = filteredDataFromTemplateData?.map((i_row) => {
                const column_master = orderedData?.find(f => f?.Tablename === getRespectiveTableName(o_items?.Tablename));
                if (column_master && column_master?.TemplateData?.length > 0) {
                  column_master?.TemplateData?.forEach((col) => {
                    const feed_back_col = getFeedBackRespectiveColumn(col);
                    const cs_col = getCsRespectiveColumn(feed_back_col);
                    const doc_col = getCsRespectiveColumn(cs_col);
                    if (feed_back_col && i_row[doc_col] && i_row[doc_col]?.toLowerCase()?.trim() === "matched" && !i_row[feed_back_col]) {
                      i_row[feed_back_col] = "Correct - Locked";
                    }
                  });
                }
                return i_row;
              })

              filteredChecklistDataMaster.push({
                Tablename: o_items?.Tablename,
                FilteredData: filteredDataFromTemplateData
              });

              return {
                ...o_items,
                TemplateData: templateDataFiltered,
              };

            });
            setChecklistData(updatedChecklistData);
            setFilteredChecklistData(filteredChecklistDataMaster);
          } else {
             const replacedOrderedData = orderedData.map(o_items => {

              if (
                ["Table 4", "Table 5", "Table 6", "Table 7"].includes(o_items?.Tablename) &&
                Array.isArray(o_items?.TemplateData)
              ) {
                const updatedTemplate = o_items.TemplateData.map(row => {
                  const updatedRow = { ...row };

                  Object.keys(updatedRow).forEach(col => {
                    if (
                      typeof updatedRow[col] === "string" &&
                      updatedRow[col].trim().toLowerCase() ===
                      "details not available in the document"
                    ) {
                      updatedRow[col] = "Form not attached in the document";
                    }
                  });

                  return updatedRow;
                });

                return {
                  ...o_items,
                  TemplateData: updatedTemplate
                };
              }

              return o_items;
            });

            setChecklistData(replacedOrderedData);
          }

          setEnableExclusionCellLock(EnableExclusionCellLockVlaue);
          setSheetRenderConfig({
            PolicyReviewChecklist: "true",
            FormsCompare: "false",
            Exclusions: "false",
            QAC_not_answered_questions: "false",
            SummaryReviewChecklist: "false"
          });
        }
        reference?.current?.showSnackbar("Data Rendered", "success", true);
        setTimeout(() => {
          reference?.current?.hideSnackbar();
        }, 500);
      }
    } catch (error) {
      console.error("Error:", error);
      setIsValue(true);
      setMsgVisible(true);
      setMsgClass("alert error");
      setMsgText(`Error fetching data: ${error}`);
      setTimeout(() => {
        setMsgVisible(false);
        setMsgText("");
      }, 3500);
      return error;
    } finally {
      document.body.classList.remove("loading-indicator");
      return "success";
    }
  };

  const getColumnsAvailableInMasterOrder = (masterData, tableName) => {
    if (tableName && masterData) {
      const orderedColumnData = [];
      masterData.forEach((f) => {
        if (
          f === "Current Term Policy" &&
          (tableName === "Table 2" || tableName === "Table 3")
        )
          orderedColumnData.push("CurrentTermPolicy");
        if (
          f === "Prior Term Policy" &&
          (tableName === "Table 2" || tableName === "Table 3")
        )
          orderedColumnData.push("PriorTermPolicy");
        if (
          f === "Proposal" &&
          (tableName === "Table 2" || tableName === "Table 3")
        )
          orderedColumnData.push("Proposal");
        if (
          f === "Quote" &&
          (tableName === "Table 2" || tableName === "Table 3")
        )
          orderedColumnData.push("Quote");
        if (
          f === "Schedule" &&
          (tableName === "Table 2" || tableName === "Table 3")
        )
          orderedColumnData.push("Schedule");
        if (
          f === "Application" &&
          (tableName === "Table 2" || tableName === "Table 3")
        )
          orderedColumnData.push("Application");
        if (
          f === "Binder" &&
          (tableName === "Table 2" || tableName === "Table 3")
        )
          orderedColumnData.push("Binder");
        if (f === "Current Term Policy - Listed" && tableName === "Table 4")
          orderedColumnData.push("CurrentTermPolicyListed");
        if (
          f === "Prior Term Policy - Listed" &&
          (tableName === "Table 4" || tableName === "Table 5")
        )
          orderedColumnData.push("PriorTermPolicyListed");
        if (
          f === "Proposal - Listed" &&
          (tableName === "Table 4" || tableName === "Table 5")
        )
          orderedColumnData.push("ProposalListed");
        if (
          f === "Binder - Listed" &&
          (tableName === "Table 4" || tableName === "Table 5")
        )
          orderedColumnData.push("BinderListed");
        if (
          f === "Schedule - Listed" &&
          (tableName === "Table 4" || tableName === "Table 5")
        )
          orderedColumnData.push("ScheduleListed");
        if (
          f === "Quote - Listed" &&
          (tableName === "Table 4" || tableName === "Table 5")
        )
          orderedColumnData.push("QuoteListed");
        if (
          f === "Application - Listed" &&
          (tableName === "Table 4" || tableName === "Table 5")
        )
          orderedColumnData.push("ApplicationListed");
        if (f === "Current Term Policy - Listed" && tableName === "Table 5")
          orderedColumnData.push("CurrentTermPolicyListed1");
        if (
          f === "Current Term Policy Attached" &&
          (tableName === "Table 5" ||
            tableName === "Table 6" ||
            tableName === "Table 7")
        )
          orderedColumnData.push("CurrentTermPolicyAttached");
        if (
          f === "Current Term Policy Listed" &&
          (tableName === "Table 5" ||
            tableName === "Table 6" ||
            tableName === "Table 7")
        )
          orderedColumnData.push("CurrentTermPolicyListed");
      });
      return orderedColumnData;
    }
    return [];
  };

  const formRender = async (jobId, processName) => {
  try {
    const updatedToken = await processAndUpdateToken(token);
    token = updatedToken;
    const headers = {
      Authorization: `Bearer ${updatedToken}`,
    };
    if (jobId && processName == "Forms Compare") {
      let csConfigData = [];
      try {
        csConfigData = await GetConfidenceScoreConfig(jobId);
        setConfidenceScoreConfig(csConfigData);
      } catch (error) {
        setConfidenceScoreConfig(confidenceScoreConfigStaticData);
      }
      let overrideConfig = null;
      try {
        overrideConfig = await getOverrideConfig(jobId);
      } catch (err) {
        overrideConfig = null;
      }
      setOverrideConfig(overrideConfig);
      let formData = await new Promise((resolve, reject) => {
        axios
          .get(
            `${baseUrl}/api/ProcedureData/GetFormDataByJobId?jobId=${jobId}`,
            { headers }
          )
          .then((response) => {
            if (response.status !== 200) {
              reject(new Error(`HTTP error! Status: ${response.status}`));
            } else {
              resolve(response.data);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
      if (
        formData[0]?.Tablename == "FormTable 1" &&
          formData[0]?.TemplateData &&
        Array.isArray(formData[0]?.TemplateData)
      ) {
        let templateData = formData[0]?.TemplateData;
        const modifiedTemplateData = [];
          const hasNameInsured = templateData?.filter((f) =>
            f?.Headers?.toLowerCase()?.includes("named insured")
          );
          const hasTerm = templateData?.filter((f) =>
            f?.Headers?.toLowerCase()?.includes("term")
          );
          const hasLob = templateData?.filter((f) =>
            f?.Headers?.toLowerCase()?.includes("lob")
          );
          const hasPol = templateData?.filter((f) =>
            f?.Headers?.toLowerCase()?.includes("pol#")
          );
          const hasCarrier = templateData?.filter((f) =>
            f?.Headers?.toLowerCase()?.includes("carrier name")
          );
          if (hasNameInsured?.length == 0) {
            modifiedTemplateData.push({
              Id: 0,
              HeaderId: 0,
              Jobid: templateData[0]?.Jobid,
              PolicyLob: templateData[0]?.PolicyLob,
              Headers: "Named Insured",
              NoColumnName: "",
            });
          }
          if (hasTerm?.length == 0) {
            modifiedTemplateData.push({
              Id: 0,
              HeaderId: 0,
              Jobid: templateData[0]?.Jobid,
              PolicyLob: templateData[0]?.PolicyLob,
              Headers: "Term",
              NoColumnName: "",
            });
          }
          if (hasLob?.length == 0) {
            modifiedTemplateData.push({
              Id: 0,
              HeaderId: 0,
              Jobid: templateData[0]?.Jobid,
              PolicyLob: templateData[0]?.PolicyLob,
              Headers: "LOB",
              NoColumnName: "",
            });
          }
          if (hasPol?.length == 0) {
            modifiedTemplateData.push({
              Id: 0,
              HeaderId: 0,
              Jobid: templateData[0]?.Jobid,
              PolicyLob: templateData[0]?.PolicyLob,
              Headers: "Pol#",
              NoColumnName: "",
            });
          }
          if (hasCarrier?.length == 0) {
            modifiedTemplateData.push({
              Id: 0,
              HeaderId: 0,
              Jobid: templateData[0]?.Jobid,
              PolicyLob: templateData[0]?.PolicyLob,
              Headers: "Carrier Name",
              NoColumnName: "",
            });
          }
          formData[0].TemplateData = [...modifiedTemplateData, ...templateData];
        }
        // if ( formData[ 1 ]?.Tablename == "FormTable 2" && formData[ 1 ]?.TemplateData?.length > 0 )
        // {
        //   formData[ 1 ].TemplateData = formsCompareDuplicateDataRemover( formData[ 1 ].TemplateData );
        //   formData[ 1 ].TemplateData = formData[ 1 ].TemplateData.map( ( e ) => {
        //     e[ "ChecklistQuestions" ] = "CA2";
        //     e[ "CoverageSpecificationsMaster" ] = "Attached Forms";
        //     return e;
        //   } );
        // }
        // if ( formData[ 2 ]?.Tablename == "FormTable 3" && formData[ 2 ]?.TemplateData?.length > 0 )
        // {
        //   formData[ 2 ].TemplateData = formsCompareDuplicateDataRemover( formData[ 2 ].TemplateData );
        //   formData[ 2 ].TemplateData = formData[ 2 ].TemplateData.map( ( e ) => {
        //     e[ "ChecklistQuestions" ] = "CA2";
        //     e[ "CoverageSpecificationsMaster" ] = "Attached Forms";
        //     return e;
        //   } );
        // }
      let EnableFormsCs = false;
      let EnableCellLock = false;
      formData = formData.map((e) => {
        if (e?.Tablename === "FormTable 1") {
          EnableFormsCs = e?.EnableCS || false;
          EnableCellLock = e?.EnableCellLock || false;
        }
          if (e?.Tablename == "FormTable 1" && e?.EnableCS && e?.MetaData) {
            const parsedData = JSON.parse(e?.MetaData);
            const usr_name = sessionStorage.getItem("userName");
            if (parsedData && parsedData?.QuestionCode?.length > 0 && parsedData?.UserName &&
              parsedData?.UserName?.toLowerCase()?.includes(usr_name?.toLowerCase())
            ) {
              let sqCodes = parsedData?.QuestionCode?.toLowerCase()?.split(',');
              if (sqCodes && sqCodes?.length > 0) {
                setSqCodesState(sqCodes);
              }
              if (sqCodes?.length > 0) {
                sqCodes = sqCodes.map((code) => { return code?.trim()?.toLowerCase() });
                e.StpMappings = e.StpMappings.filter((f) => !sqCodes?.includes(f?.ShortQuestion?.trim()?.toLowerCase()))
              }
            }
          }
          else if (e?.Tablename === "FormTable 2") {
            if (e?.TemplateData?.length > 0 && EnableFormsCs) {
          const minCellLockScore = confidenceScoreConfig?.find(csc => csc?.Key === "MinLockCellScore")?.Value;

          e.TemplateData = e.TemplateData.map((fc_data) => {
            const lockableColumns = getLockableColumns(e?.IsArJob, e?.IsSsdJob, overrideConfig);

                ["CurrentTermPolicyAttachedCs", "PriorTermPolicyAttachedCs"].forEach(csCol => {
                  const fbCol = csCol === "CurrentTermPolicyAttachedCs" ? "CtAttachedFeedback" : "PtAttachedFeedback";
                const cs_score = fc_data[csCol];

                  if (cs_score?.trim() && cs_score?.toLowerCase() !== "details not available in the document") {
                    if (parseFloat(cs_score) >= (minCellLockScore ? parseFloat(minCellLockScore) : 95)) {
                      fc_data[fbCol] = "Correct - Locked";
                    } else if (
                      parseFloat(cs_score) <= (minCellLockScore ? parseFloat(minCellLockScore) : 95) &&
                      (
                        overrideConfig?.Question?.trim().toLowerCase() === "all" ||
                        overrideConfig?.Question
                          ?.split(",")
                          ?.map(q => q.trim().toLowerCase())
                          .includes(fc_data["ChecklistQuestions"]?.trim()?.slice(0, 3)?.toLowerCase())
                      ) &&
                      lockableColumns[csCol]
                  ) {
                    fc_data[fbCol] = "Correct - Locked";
                  }
                }
              });

            return fc_data;
          });
        }
          }
          else if (e?.Tablename === "FormTable 3") {
            if (e?.TemplateData?.length > 0 && EnableFormsCs) {
              const minCellLockScore = confidenceScoreConfig?.find(csc => csc?.Key === "MinLockCellScore")?.Value;
              e.TemplateData = e.TemplateData.map((fc_data) => {
                const lockableColumns = getLockableColumns(e?.IsArJob, e?.IsSsdJob, overrideConfig);

                ["CurrentTermPolicyAttachedCs", "PriorTermPolicyAttachedCs"].forEach(csCol => {
                  const fbCol = csCol === "CurrentTermPolicyAttachedCs" ? "CtAttachedFeedback" : "PtAttachedFeedback";
                  const cs_score = fc_data[csCol];

                  if (cs_score?.trim() && cs_score?.toLowerCase() !== "details not available in the document") {
                    if (parseFloat(cs_score) >= (minCellLockScore ? parseFloat(minCellLockScore) : 95)) {
                      fc_data[fbCol] = "Correct - Locked";
                    } else if (
                      parseFloat(cs_score) <= (minCellLockScore ? parseFloat(minCellLockScore) : 95) &&
                      (
                        overrideConfig?.Question?.trim().toLowerCase() === "all" ||
                        overrideConfig?.Question
                          ?.split(",")
                          ?.map(q => q.trim().toLowerCase())
                          .includes(fc_data["ChecklistQuestions"]?.trim()?.slice(0, 3)?.toLowerCase())
                      ) &&
                      lockableColumns[csCol]
                    ) {
                      fc_data[fbCol] = "Correct - Locked";
                    }
                  }
                });

                return fc_data;
          });
        }
          }
           formData = formData.map(sheet => {

            if (
              sheet.Tablename === "FormTable 2" ||
              sheet.Tablename === "FormTable 3"
            ) {
              if (Array.isArray(sheet.TemplateData) && sheet.TemplateData.length > 0) {
                sheet.TemplateData = sheet.TemplateData.map(row => {
                  const {
                    CoverageSpecificationsMaster,
                    ChecklistQuestions,
                    ...rest
                  } = row;

                  return {
                    ...rest,

                    CurrentTermPolicyAttached: rest.CurrentTermPolicyAttached ?? "Details not available in the document",
                    PriorTermPolicyAttached: rest.PriorTermPolicyAttached ?? "Details not available in the document"
                  };
                });
              }
              else {
                sheet.TemplateData = [
                  {
                    Observation: "",
                    PolicyLob: "",
                    PageNumber: "",
                    IsMatched: ""
                  }
                ];
              }
            }

            return sheet;
          }); 
          return e;
});
      setFormData(formData);
      setSheetRenderConfig({
        PolicyReviewChecklist: "false",
        FormsCompare: "true",
        Exclusions: "false",
        QAC_not_answered_questions: "false",
        SummaryReviewChecklist: "false",
      });
    }
  } catch (error) {
    console.error("Error:", error);
    return error;
  } finally {
    return "success";
  }
};

  const exclusionRender = async (jobId, processName) => {
  try {
    const updatedToken = await processAndUpdateToken(token);
    token = updatedToken;
    const headers = {
      Authorization: `Bearer ${updatedToken}`,
    };

    if (jobId && (processName == "Exclusions" || processName == "csrExclusion")) {
      const apiEndPoint =
        processName == "csrExclusion"
          ? "api/ProcedureData/GetCsrExclusionData?JobId"
          : "api/ProcedureData/GetExclusionData?JobId";

      let exclusionData = await new Promise((resolve, reject) => {
        axios
          .get(`${baseUrl}/${apiEndPoint}=${jobId}`, { headers })
          .then((response) => {
            if (response.status !== 200) {
              reject(new Error(`HTTP error! Status: ${response.status}`));
            } else {
              resolve(response.data);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });

      if (exclusionData && exclusionData?.length > 0) {
        if (processName != "csrExclusion") {
          exclusionData = exclusionData?.map((Obj) => {
            if (!Obj?.ConfidenceScore) {
              Obj["ConfidenceScore"] =
                "Details not available in the document";
            }
            return Obj;
          });

          const minCellLockScore = confidenceScoreConfig?.find(
            (csc) => csc?.Key === "MinLockCellScore"
          )?.Value;

          exclusionData = exclusionData.map((fc_data) => {
            const cs_score = fc_data["ConfidenceScore"];

            if (props?.overrideConfig?.ExclusionEnabled) {
              fc_data["ExclusionFeedback"] = "Correct - Locked";
            } 
            else if (cs_score?.trim() && cs_score?.toLowerCase() !== "details not available in the document" && parseFloat(cs_score) >= (minCellLockScore ? parseFloat(minCellLockScore) : 95)) {
              fc_data["ExclusionFeedback"] = "Correct - Locked";
            }

            return fc_data;
          });
        }
      } else {
        if (processName == "Exclusions") {
          exclusionData = staticExclusionData;
        } else if (processName == "csrExclusion") {
          exclusionData = staticExclusionCsrData;
        }
      }

      exclusionData = exclusionData?.map((item) => {
        item["Document Viewer"] = item["DocumentViewer"];
        delete item["DocumentViewer"];
        return item;
      });

  exclusionData = exclusionData?.sort((a, b) => {

  const aValue = (a?.Exclusion ?? "").toString().trim();
  const bValue = (b?.Exclusion ?? "").toString().trim();

  const aHasText = aValue !== "" && aValue !== "-";
  const bHasText = bValue !== "" && bValue !== "-";

  if (aHasText && !bHasText) return -1;
  if (!aHasText && bHasText) return 1;

  const getFirstPage = (page) => {
    if (!page) return Number.MAX_SAFE_INTEGER;

    const match = page.toString().match(/\d+/);
    return match ? parseInt(match[0], 10) : Number.MAX_SAFE_INTEGER;
  };

  const aPage = getFirstPage(a?.PageNumber);
  const bPage = getFirstPage(b?.PageNumber);

  return aPage - bPage;
});

      setExclusionData(exclusionData);
     setSheetRenderConfig({
        SummaryChecklist: "false",
        FormsCompare: "false",
        Exclusions: "true",
        QAC_not_answered_questions: "false",
      });
    }
  } catch (error) {
    console.error("Error:", error);
    return error;
  } finally {
    return "success";
  }
};


  const summaryReviewChecklistRender = async (jobId, sheetFlag) => {
    try {
      const updatedToken = await processAndUpdateToken(token);
      token = updatedToken;
      const headers = {
        Authorization: `Bearer ${updatedToken}`,
      };

      if (jobId !== undefined && sheetFlag !== undefined) {
        const apiEndPoint = `api/ProcedureData/GetSummaryReviewChecklistByJobId?jobId=${jobId}&isDataForCsr=${sheetFlag}`;  //${sheetFlag}

        const response = await axios.get(`${baseUrl}/${apiEndPoint}`, { headers });

        if (response.status !== 200) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = response.data;

        if (data) {
          setSummaryReviewChecklistData(data);
        } else {
          setSummaryReviewChecklistData(staticSummaryReviewChecklistData);
        }

        setSheetRenderConfig({
          PolicyReviewChecklist: "false",
          FormsCompare: "false",
          Exclusions: "false",
          QAC_not_answered_questions: "false",
          SummaryReviewChecklist: "true",
        });
      }

      return "success";
    } catch (error) {
      console.error("Error:", error);
      return error;
    }
  };

  const QACDataRender = async (jobId, token) => {
    const defaultData = { data: {} };
    if (jobId) {
      try {
        const Token = await processAndUpdateToken(token);
        const headers = {
          'Authorization': `Bearer ${Token}`,
          "Content-Type": "application/json",
        };
        const response = await axios.get(baseUrl + '/api/Defaultdatum/GetQacChecklistData?jobId=' + jobId, {
          headers
        });
        if (response.status !== 200) {
          return defaultData;
        }
        if (response?.data && response?.data?.JsonData) {
          if (response?.data?.JsonData) {
            setCsrQacData(response?.data?.JsonData);
            return { data: response?.data?.JsonData };
          } else {
            return defaultData;
          }
        } else {
          return defaultData;
        }
      } catch (error) {
        return defaultData;
      }
    }
    return defaultData;
  };

  const renderComponent = () => {
    const getUserName = defaultSheetNameData;
    console.log("getUserName", getUserName)
    let sessionUserName = sessionStorage.getItem('userName');

    const macro = checklistypeState?.MacroFile;

    if ((location.pathname === "/csrView" || location.pathname === "/csrview") && jobId) {
      const broker_Id = jobId?.substring(0, 4);
      const isGradiationCheck = ["1003", "1099", "1121"]?.includes(broker_Id);

      const isGradation = macro === "Gradation";
      const isCsrPro = macro === "CSR Pro";

      if (isCsrPro) {
        return (
          <CsrSheet
            isCsrProOnly={true}
            summaryReviewChecklistData={summaryReviewChecklistData}
            isLobSplitJob={summaryReviewChecklistData?.IsLobSplitJob}
            defaultSheetUserNameData={defaultSheetNameData}
            selectedJob={jobId}
            selectedJobName={jobName}
            checklistypeState={checklistypeState}
          />
        );
      }

      return (
        <CsrSheet
          isCsrProOnly={false}
          data={isGradiationCheck && isGradation ? null : csrChecklistData}
          gradtionDataSet={isGradiationCheck && !isGradation ? null : gradtionData}
          formCompareData={csrFormsData}
          exclusionRenderData={exclusionData}
          qacData={csrQacData}
          qacdataapi={Qacdata}
          summaryReviewChecklistData={summaryReviewChecklistData}
          isLobSplitJob={summaryReviewChecklistData?.IsLobSplitJob}
          defaultSheetUserNameData={defaultSheetNameData}
          selectedJob={jobId}
          selectedJobName={jobName}
          checklistypeState={checklistypeState}
        />
      );
    }

    const commonProps = {
      data: checklistData,                 // original (for save)
      filteredChecklistData: filteredChecklistData,
      // useFilteredData: Array.isArray(filteredChecklistData) && filteredChecklistData.length > 0,
      isCosmosFlag: checklistData?.find((f) => f.Tablename === "JobHeader")?.IsCosmosFlag,
      IsSsdJob: checklistData?.find((f) => f.Tablename === "JobHeader")?.IsSsdJob,
      HasEndorsement: checklistData?.find((f) => f.Tablename === "JobHeader")?.HasEndorsement,
      enableCs: checklistData?.find((f) => f.Tablename === "JobHeader")?.EnableCS,
      sqCodes: sqCodesState,
      IsArJob: checklistData?.find((f) => f.Tablename === "JobHeader")?.IsArJob,
      enableCellLock: checklistData?.find((f) => f.Tablename === "JobHeader")?.EnableCellLock,
      enableFormsCs: checklistData?.find((f) => f.Tablename === "JobHeader")?.EnableFormsCs,
      enableExclusionCellLock: enableExclusionCellLock,
      csMeatData: checklistData?.find((f) => f.Tablename === "JobHeader")?.MetaData,
      formCompareData: formData,
      formsCompareHeaderData: formData?.find((f) => f.Tablename === "FormTable 1"),
      exclusionRenderData: exclusionData,
      summaryReviewChecklistData: summaryReviewChecklistData,
      isLobSplitJob: summaryReviewChecklistData?.IsLobSplitJob,
      selectedJob: jobId,
      qacdataapi: Qacdata,
      gradtionDataSet: gradtionData,
      selectedJobName: jobName,
      sheetOptionSet: sheetListOptionSet || ["Summary Checklist", "Forms Compare", "Exclusions", "QAC not answered questions"],
      selectedSheet: selectedSheet,
      sheetRenderConfig: sheetRenderConfig,
      confidenceScoreConfig: confidenceScoreConfig,
      selectChange: async (value) => {
        setIsValue(false);
        setIsReadonly(false);
        await ComponentRenderApiFun();
        if (value === "Forms Compare") {
          await formRender(jobId, "Forms Compare");
        } else if (value === "Summary Checklist") {
          await dataRender(jobId, "Summary Checklist");
        } else if (value === "Exclusions") {
          await exclusionRender(jobId, "Exclusions");
        } else if (value === "SummaryReviewChecklist") {
          const isCsrView = location.pathname === "/csrView" || location.pathname === "/csrview";
          await summaryReviewChecklistRender(jobId, isCsrView);
        } else if (value === "QAC not answered questions") {
          setSheetRenderConfig({
            PolicyReviewChecklist: "false",
            FormsCompare: "false",
            Exclusions: "false",
            SummaryReviewChecklist: "false",
            QAC_not_answered_questions: "true",
          });
        }
        setSelectedSheet(value);
        setIsValue(true);
        setIsReadonly(true);
      },
    };

    return (getUserName === sessionUserName || !getUserName) ? (
      <Luckysheet {...commonProps} />
    ) : (
      <DefaultDataSheet {...commonProps} />
    );
  };

  const GetGradationData = async (jobId, path) => {
    try {
      if (jobId) {
        const updatedToken = await processAndUpdateToken(token);
        token = updatedToken;
        const headers = { Authorization: `Bearer ${updatedToken}` };
        let url = "";
        if (path === "/csrView" || path === "/csrview") {
          url = "/api/ProcedureData/GetGradiationGridData?JobId=";
        } else {
          url = "/api/ProcedureData/GetGradationDataByJobId?JobId=";
        }
        const response = await axios.get(baseUrl + url + jobId, {
          headers,
        });
        if (response.status == 200) {
          if (path === "/csrView" || path === "/csrview") {
            if (response?.data?.IsApplicable) {
              setGradtionData(response?.data?.Response);
            }
          } else {
            setGradtionData(response.data);
          }
          return "success";
        } else {
          //handle error's
          // throw new Error( `HTTP error! Status: ${ response.status }` );
        }
      }
    } catch (error) {
      //handle error
    }
  };

  const ExportQac = async (JobId) => {
    const Token = await processAndUpdateToken(token);
    const headers = {
      Authorization: `Bearer ${Token}`,
    };
    axios
      .get(baseUrl + "/api/Excel/SplitDataByPolicyLob?JobId=" + JobId, { headers })
      .then((response) => {
        if (response.status !== 200) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const qacdata = response.data;
        setQacdata(qacdata);
      })
      .catch((error) => {
        // Handle errors...
      })
      .finally(() => {
        // document.body.classList.remove('loading-indicator');
      });
  };

  return (
    <div className="main-container">
      <div className="app-container">
        {/* <div>
          <AppSidebar />
        </div> */}
        <div>
          {msgVisible && (
            <div className="alert-container">
              <div className={msgClass}>{msgText}</div>
            </div>
          )}
          {isValue && isReadonly && renderComponent()}
          <br />
        </div>
        <SimpleSnackbarWithOutTimeOut ref={reference} />
      </div>
    </div>
  );
}
export default App;